import React from "react";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Chip,
  Stack,
  Typography,
} from "@mui/material";
import { capitalize } from "lodash";
import styles from "./VendorManagement.module.css";
import ZoomOutMapIcon from '@mui/icons-material/ZoomOutMap';

const VendorCard = ({ vendor, onView }) => {
  const displayName = vendor?.company_name || "Vendor";
  const initials = displayName
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();

  return (
    <>
    <Card className={styles.vendorCard}>
      <Box className={styles.viewIcon}   onClick={() => onView(vendor)}>
        <ZoomOutMapIcon className={styles.viewIconSvg} />
      </Box>
      <CardContent className={styles.cardContent}>
        <Avatar className={styles.avatar}>{initials}</Avatar>
        <Typography variant="h6" className={styles.cardTitle}>
          {displayName}
        </Typography>
        <Typography variant="body2" className={styles.cardCompanyName}>
          {vendor?.company_name || "Company details unavailable"}
        </Typography>
        <Stack direction="row" spacing={1} className={styles.chipRow}>
          <Chip label={vendor?.club || "N/A"} size="small" className={styles.chipPrimary} />
          <Chip label="vendor" size="small" className={styles.chipSecondary} />
        </Stack>
        <Box className={styles.infoBox}>
          <Typography variant="body2" className={styles.infoText}>
            <strong>Location:</strong> {capitalize(vendor?.city || "-")}, {capitalize(vendor?.state || "-")}
          </Typography>
          <Typography variant="body2" className={styles.infoText}>
            <strong>Company size:</strong> {vendor?.company_size || "-"}
          </Typography>
          <Typography variant="body2" className={styles.infoText}>
            <strong>Vendor ID:</strong> {vendor?.vendor_company_id || "-"}
          </Typography>
        </Box>
      </CardContent>
      </Card>
    </>
  );
};

export default VendorCard;
